/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { tunneledMcpListServerConnections } from "../funcs/tunneledMcpListServerConnections.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { TunneledMcpServerConnections } from "../models/components/tunneledmcpserverconnections.js";
import {
  ListTunneledMcpServerConnectionsRequest,
  ListTunneledMcpServerConnectionsSecurity,
} from "../models/operations/listtunneledmcpserverconnections.js";
import { unwrapAsync } from "../types/fp.js";
export type ListTunneledMcpServerConnectionsQueryData =
  TunneledMcpServerConnections;

export function prefetchListTunneledMcpServerConnections(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListTunneledMcpServerConnectionsRequest,
  security?: ListTunneledMcpServerConnectionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListTunneledMcpServerConnectionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListTunneledMcpServerConnectionsQuery(
  client$: GramCore,
  request: ListTunneledMcpServerConnectionsRequest,
  security?: ListTunneledMcpServerConnectionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListTunneledMcpServerConnectionsQueryData>;
} {
  return {
    queryKey: queryKeyListTunneledMcpServerConnections({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function listTunneledMcpServerConnectionsQueryFn(
      ctx,
    ): Promise<ListTunneledMcpServerConnectionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(tunneledMcpListServerConnections(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListTunneledMcpServerConnections(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "tunneledMcp", "listServerConnections", parameters];
}
